import { render, staticRenderFns } from "./c-draggable-step-number.vue?vue&type=template&id=f45f67a8&"
import script from "./c-draggable-step-number.vue?vue&type=script&lang=js&"
export * from "./c-draggable-step-number.vue?vue&type=script&lang=js&"
import style0 from "./c-draggable-step-number.vue?vue&type=style&index=0&id=f45f67a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports